import Svg from 'components/utilities/svg'

const HomeIcon = ({ ...props }) => (
  <Svg viewBox="0 0 24 24" {...props}>
    <path d="M4 21v-9.375L2.2 13 1 11.4l3-2.3V6h2v1.575L12 3l11 8.4-1.2 1.575-1.8-1.35V21h-6.432v-6h-3.125v6z" />
  </Svg>
)

HomeIcon.displayName = 'Home'

export default HomeIcon
